module.exports = __webpack_public_path__ + "static/media/logo2.32484067.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo2.svg
// module id = 47
// module chunks = 8